import { jwtDecode, JwtPayload } from 'jwt-decode'

const accessTokenName = 'jwt_at'
const refreshTokenName = 'jwt_rt'

export const getAccessToken = (
  decoded = false
): JwtPayload | string | undefined => {
  const token = sessionStorage.getItem(accessTokenName)
  if (!decoded) return token || undefined
  try {
    return token ? jwtDecode(token) : undefined
  } catch {}
}

export const setAccessToken = (token: string | undefined) => {
  if (token === undefined) {
    sessionStorage.removeItem(accessTokenName)
  } else {
    sessionStorage.setItem(accessTokenName, token)
  }
}

export const removeAccessToken = () => {
  sessionStorage.removeItem(accessTokenName)
}

export const getRefreshToken = (
  decoded = false
): JwtPayload | string | undefined => {
  const tokenLocal = localStorage.getItem(refreshTokenName) as string
  const tokenSession = sessionStorage.getItem(refreshTokenName) as string
  const token = tokenLocal || tokenSession
  if (!decoded) return token || undefined
  try {
    return token ? jwtDecode(token) : undefined
  } catch {}
}

export const setRefreshToken = (
  token: string | undefined,
  remember?: boolean
) => {
  if (remember === undefined && localStorage.getItem(refreshTokenName)) {
    remember = true
  }
  if (remember) {
    if (token === undefined) {
      localStorage.removeItem(refreshTokenName)
    } else {
      localStorage.setItem(refreshTokenName, token)
    }
    sessionStorage.removeItem(refreshTokenName)
  } else {
    if (token === undefined) {
      sessionStorage.removeItem(refreshTokenName)
    } else {
      sessionStorage.setItem(refreshTokenName, token)
    }
    localStorage.removeItem(refreshTokenName)
  }
}

export const removeRefreshToken = () => {
  localStorage.removeItem(refreshTokenName)
  sessionStorage.removeItem(refreshTokenName)
}

export const clearTokens = () => {
  removeAccessToken()
  removeRefreshToken()
}

export const hasToken = () => {
  return !!getAccessToken() || !!getRefreshToken()
}
